import React, { useState } from 'react';
import axios from 'axios';
import { useEffect } from 'react';
import { generateAxiosInstanceSection } from '../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceCommon } from '../hooks/useAuthorizedReuestCommon';
import { Loader } from './ModalsCommonFunctions';

const authorizedAxiosSection = generateAxiosInstanceSection()
const authorizedAxiosCommon = generateAxiosInstanceCommon()

const GetAddress = ({ isDevice, uniqueId, resetTrigger }) => {
    const [loading, setLoading] = useState(false);
    const [latLong, setLatLong] = useState({});
    const [address, setAddress] = useState({});
    const [error, setError] = useState('');

    const resetState = () => {
        setLatLong({});
        setAddress({});
        setError('');
    };

    useEffect(() => {
        resetState();
    }, [resetTrigger]);

    const GetAddressData = async () => {
        try {
            setLoading(true);

            const urlStudent = `view-cureent-location?userUniqueId=${uniqueId}`;
            const urlDevice = `view-device-location?device_id=${uniqueId}`;

            let data;
            if (isDevice) {
                const response = await authorizedAxiosCommon.get(urlDevice);
                data = response.data.data;
            } else {
                const response = await authorizedAxiosSection.get(urlStudent);
                data = response.data.data;
            }

            setLatLong(data);

            const url2 = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${data.latitude}&lon=${data.longitute}`;
            const response = await axios.get(url2);
            const address = response.data.address;

            if (address) {
                setAddress(address);
                setError('');
            } else {
                setAddress({});
                setError('No address found for these coordinates.');
            }
        } catch (error) {
            setAddress('');
            setError('Unable to retrieve address.');
        } finally {
            setLoading(false);
        }
    };

    const handleButtonClick = () => {
        GetAddressData();
    };

    const redirectToGoogleMaps = () => {
        const { latitude, longitute } = latLong;

        // Check if Geolocation is available
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude: currentLat, longitude: currentLon } = position.coords;
                    const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${currentLat},${currentLon}&destination=${latitude},${longitute}`;
                    window.open(googleMapsUrl, '_blank');
                },
                (error) => {
                    console.error('Error getting location:', error);
                    alert('Unable to get your current location.');
                }
            );
        } else {
            alert('Geolocation is not supported by this browser.');
        }
    };

    return (
        <>
            <Loader loading={loading} />
            <div className="container mt-5">
                <div className="text-center mb-4">
                    <h1 className="display-4 mb-3 text-primary font-weight-bold">Address Lookup</h1>
                    {Object.keys(latLong).length > 0 && <>
                        <p className="lead mb-4">
                            <span className="font-weight-bold">Latitude:</span> {latLong.latitude}
                        </p>
                        <p className="lead mb-4">
                            <span className="font-weight-bold">Longitude:</span> {latLong.longitute}
                        </p></>}

                    {error && <p className="text-danger mt-3">{error}</p>}
                </div>

                {Object.keys(address).length > 0 && <div className="d-flex justify-content-center mb-4">
                    <div className="card p-4 border-0 shadow-lg" style={{ maxWidth: '600px', width: '100%' }}>
                        <div className="card-body">
                            <div className="row">
                                {address.country && (
                                    <div className="col-md-12 mb-2">
                                        <div className="d-flex justify-content-between">
                                            <span className="font-weight-bold text-dark">Country:</span>
                                            <span>{address.country}</span>
                                        </div>
                                    </div>
                                )}
                                {address.state && (
                                    <div className="col-md-12 mb-2">
                                        <div className="d-flex justify-content-between">
                                            <span className="font-weight-bold text-dark">State:</span>
                                            <span>{address.state}</span>
                                        </div>
                                    </div>
                                )}
                                {address.state_district && (
                                    <div className="col-md-12 mb-2">
                                        <div className="d-flex justify-content-between">
                                            <span className="font-weight-bold text-dark">District:</span>
                                            <span>{address.state_district}</span>
                                        </div>
                                    </div>
                                )}
                                {address.city && (
                                    <div className="col-md-12 mb-2">
                                        <div className="d-flex justify-content-between">
                                            <span className="font-weight-bold text-dark">City:</span>
                                            <span>{address.city}</span>
                                        </div>
                                    </div>
                                )}
                                {address.town && (
                                    <div className="col-md-12 mb-2">
                                        <div className="d-flex justify-content-between">
                                            <span className="font-weight-bold text-dark">Town:</span>
                                            <span>{address.town}</span>
                                        </div>
                                    </div>
                                )}
                                {address.road && (
                                    <div className="col-md-12 mb-2">
                                        <div className="d-flex justify-content-between">
                                            <span className="font-weight-bold text-dark">Road:</span>
                                            <span>{address.road}</span>
                                        </div>
                                    </div>
                                )}
                                {address.postcode && (
                                    <div className="col-md-12 mb-2">
                                        <div className="d-flex justify-content-between">
                                            <span className="font-weight-bold text-dark">Pincode:</span>
                                            <span>{address.postcode}</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>}
                <div className="text-center mb-4">
                    <button
                        className="btn btn-primary btn-lg rounded-pill shadow-sm"
                        onClick={handleButtonClick}
                    >
                        Get Current Address
                    </button>
                    <button
                        className={`btn btn-secondary btn-lg rounded-pill shadow-sm`}
                        style={{ marginLeft: '10px' }}
                        onClick={redirectToGoogleMaps}
                        disabled={Object.keys(latLong).length === 0}
                    >
                        View Directions to Location
                    </button>
                </div>
            </div>
        </>
    );
};

export default GetAddress;
